<template>
  <Modal hide-close-button>
    <QCard class="q-pa-sm">
      <QCardSection class="row justify-center">
        <span>
          {{ text }}
        </span>
      </QCardSection>
    </QCard>

    <template #buttons="{ close }">
      <QBtn
        class="q-ma-sm"
        label="Okay"
        @click.prevent="close"
      />
    </template>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "UndeliveredRecipientsModal",
  components: {
    Modal,
  },
  props: {
    deliveredRecipients: {
      type: Array,
      required: true,
    },
    recipientsList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    notDeliveredRecipients() {
      if (this.recipientsList && this.deliveredRecipients) {
        return this.recipientsList.filter(
          (recipient) => !this.deliveredRecipients.includes(recipient)
        );
      }

      return [];
    },
    text() {
      if (this.recipientsList && this.deliveredRecipients) {
        if (this.recipientsList.length === this.deliveredRecipients.length) {
          return "Delivered to all recipients";
        }

        let text = `Not delivered to: ${this.notDeliveredRecipients
          .slice(0, 4)
          .join(", ")}`;

        if (this.notDeliveredRecipients.length > 4) {
          text += `(+${this.notDeliveredRecipients.length - 4})`;
        }

        return text;
      }

      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.streem-dialog {
  background-color: rgb(255 255 255);
}
</style>
